export default "__VITE_ASSET__9b7f1b08__"